// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"8616a51e","436":"f54461a6","442":"66692bb1","563":"b5f43444","622":"c292ac36","727":"9d29f8e3","759":"c17a8e80","785":"021a88ad"}[chunkId] + ".chunk.js";
};